"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { indexedDBService } from "./IndexedDBService";
import { csvParserService } from "./CsvParserService";
class S3DataService {
  constructor() {
    this.baseUrl = "/api/v4/reports/s3_csv";
  }
  fetchPresignedUrl(entityId, year, month, recordType) {
    return __async(this, null, function* () {
      const response = yield fetch(
        `${this.baseUrl}?entity_id=${entityId}&year=${year}&month=${month}&record_type=${recordType}`
      );
      const data = yield response.json();
      if (!data.url) {
        return null;
      }
      return data.url;
    });
  }
  downloadAndProcessCsv(url, recordType) {
    return __async(this, null, function* () {
      try {
        const response = yield fetch(url, {
          credentials: "omit",
          // Don't send cookies to S3
          headers: {
            Accept: "text/csv,application/json,text/plain,*/*"
          }
        });
        const data = yield response.text();
        return csvParserService.parseCSV(data, recordType);
      } catch (error) {
        console.error("Error downloading or processing CSV:", error);
        throw error;
      }
    });
  }
  downloadPastYearData(options) {
    return __async(this, null, function* () {
      const { entityIds, recordType, onProgress } = options;
      const currentDate = /* @__PURE__ */ new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const monthsToDownload = [];
      for (const entityId of entityIds) {
        for (let i = 0; i < 12; i++) {
          let month = currentMonth - i;
          let year = currentYear;
          if (month <= 0) {
            month += 12;
            year -= 1;
          }
          const existingData = yield indexedDBService.getChartData(entityId, year, month, recordType);
          if (!existingData) {
            monthsToDownload.push({ entityId, year, month });
          }
        }
      }
      const totalToDownload = monthsToDownload.length;
      const progress = {
        total: totalToDownload,
        completed: 0,
        percentage: 0,
        status: "downloading"
      };
      if (onProgress) {
        onProgress(progress);
      }
      try {
        let completedDownloads = 0;
        for (const { entityId, year, month } of monthsToDownload) {
          const url = yield this.fetchPresignedUrl(entityId, year, month, recordType);
          if (!url) {
            yield indexedDBService.saveChartData(entityId, year, month, recordType, {
              reportNotFound: true
            });
          } else {
            const data = yield this.downloadAndProcessCsv(url, recordType);
            yield indexedDBService.saveChartData(entityId, year, month, recordType, data);
          }
          completedDownloads++;
          progress.completed = completedDownloads;
          progress.percentage = totalToDownload > 0 ? Math.round(completedDownloads / totalToDownload * 100) : 100;
          if (onProgress) {
            onProgress(__spreadValues({}, progress));
          }
        }
        if (onProgress) {
          onProgress(__spreadProps(__spreadValues({}, progress), {
            status: "processing"
          }));
        }
        const allData = yield indexedDBService.getAggregatedData(entityIds, recordType);
        if (onProgress) {
          onProgress(__spreadProps(__spreadValues({}, progress), {
            status: "complete"
          }));
        }
        return allData;
      } catch (error) {
        if (onProgress) {
          onProgress(__spreadProps(__spreadValues({}, progress), {
            status: "error",
            error: error.message
          }));
        }
        throw error;
      }
    });
  }
}
export const s3DataService = new S3DataService();
